const getPath = (location: Location) => location.pathname || '';

const getQuery = (location: Location) => location.search || '';

const getHash = (location: Location) => location.hash || '';

const makeAbsolute = (location: Location, url: string) =>
    `${location.protocol}//${location.host}${url}`;

export { getPath, getHash, getQuery, makeAbsolute };
